/**
 * Masks a secret value by showing only first and last characters.
 * Used for displaying sensitive data like tokens, certificates, API keys.
 *
 * @param value - The value to mask
 * @param type - 'input' for single-line inputs (shorter reveal), 'textarea' for multi-line (longer reveal)
 * @returns Masked string like "abcd••••••••wxyz"
 */
export function maskValue(
  value: string,
  type: "input" | "textarea" = "input"
): string {
  if (!value) return "";

  const threshold = type === "input" ? 12 : 20;
  if (value.length < threshold)
    return "•".repeat(value.length);

  const showChars = type === "input" ? 4 : 10;
  const maxDots = type === "input" ? 20 : 50;

  return `${value.slice(0, showChars)}${"•".repeat(Math.min(value.length - showChars * 2, maxDots))}${value.slice(-showChars)}`;
}
